import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { initOneSignal, loginOneSignal, logoutOneSignal } from "../lib/oneSignal";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchMe = useCallback(async () => {
        const token = localStorage.getItem("hp_token");
        if (!token) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            localStorage.removeItem("hp_token");
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // Init OneSignal once on app boot
        initOneSignal();
        fetchMe();
    }, [fetchMe]);

    // Sync OneSignal external_id with our user id whenever auth changes
    useEffect(() => {
        if (user?.id) loginOneSignal(user.id);
    }, [user?.id]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("hp_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        localStorage.setItem("hp_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const registerDoctor = async (payload) => {
        const { data } = await api.post("/doctors/register", payload);
        localStorage.setItem("hp_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        localStorage.removeItem("hp_token");
        setUser(null);
        logoutOneSignal();
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, registerDoctor, logout, refresh: fetchMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
